query ImageFile($id: ID!) {
  file: image(id: $id) {
    id
    url
  }
}
